/**
 * Card Component
 * Reusable card container with shadow and border
 */

import React, { type ReactNode } from 'react';

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  className?: string;
  hoverable?: boolean;
}

const Card = React.forwardRef<HTMLDivElement, CardProps>(
  ({ children, className = '', hoverable = false, ...props }, ref) => {
    const baseClasses = 'bg-white rounded-lg border border-gray-200 p-6 shadow-sm';
    const hoverClass = hoverable ? 'hover:shadow-md hover:-translate-y-1 transition-all duration-300' : '';

    return (
      <div
        ref={ref}
        className={`${baseClasses} ${hoverClass} ${className}`}
        {...props}
      >
        {children}
      </div>
    );
  }
);

Card.displayName = 'Card';

export default Card;
